import React, { FC, useContext, useState } from "react";
import { Tooltip } from "@datassential/platform-ui-lib";
import { AiOutlineInfoCircle } from "react-icons/ai";
import Button, { ButtonTypeEnum } from "../../../../components/new/Button/Button";
import SectionHeader from "../../../../components/new/SectionHeader/SectionHeader";
import { IconYoutubeNew } from "../../../../icons";
import ItemYoutube from "./ItemYoutube/ItemYoutube";
import "./Socials.styles.scss";
import Modal from "../../../../components/Modal/Modal";
import { ChainDetailsDataContext } from "../../ChainPage.helpers";
import SectionContent from "../../../../components/new/SectionContent/SetionContent";
import BrandPerceptionsSocialPanel from "@pages/Home/sections/HomeBrandPerceptions/BrandPerceptionsSocialPanel";

const SOCIAL_LISTENING_TOOLTIP_ID = 'chain-socials-social-listening-info';

const Socials: FC = () => {
    const {
        data: {
            mainData: {
                socialLinks,
                id: chainId,
                name: chainName,
            }
        },
        socialLinksData: data,
        isLoadingSocialLinks: isLoading,
        chainSocialData,
        isLoadingChainSocial: isChainSocialLoading,
    } = useContext(ChainDetailsDataContext);
    const [selectedYoutubeUrl, setSelectedYoutubeUrl] = useState<string | null>(null);

    const hasData = data.twitter.length > 0 || data.youtube.length > 0 || chainSocialData.hasData;

    return (
        <div className="Socials">
            <SectionHeader title="Social"/>
            <SectionContent isLoading={isLoading} className="Socials__content">
                {!isChainSocialLoading && chainSocialData.hasData && (
                    <>
                        <div
                            className="Socials__social-header"
                            data-testid="blockChainSocialListeningHeader"
                        >
                            <div
                                className="Socials__social-header-title"
                                data-testid="textChainSocialListeningTitle"
                            >
                                Social Listening
                            </div>
                            <AiOutlineInfoCircle
                                className="Socials__info-icon"
                                data-tooltip-id={SOCIAL_LISTENING_TOOLTIP_ID}
                                data-testid="iconChainSocialListeningInfo"
                            />
                            <Tooltip id={SOCIAL_LISTENING_TOOLTIP_ID} place="bottom-start">
                                <div className="Socials__tooltip">
                                    <div style={{ marginBottom: 5 }}><b>Data Details</b></div>
                                    <ul>
                                        <li>updated weekly</li>
                                        <li>cleaned and vetted by Datassential trend experts</li>
                                        <li>sources include: TikTok, Instagram, Pinterest, YouTube, X, Reddit</li>
                                        <li>reflects US & Canadian social activity</li>
                                    </ul>
                                </div>
                            </Tooltip>
                        </div>
                        <BrandPerceptionsSocialPanel
                            chainId={chainId}
                            chainName={chainName}
                            chainData={chainSocialData}
                        />
                    </>
                )}
                {data && (
                    <>
                        {data.youtube.length > 0 && (
                            <div className="Socials__section">
                                <div className="Socials__title">
                                    <IconYoutubeNew className="Socials__title-icon"/> Youtube
                                </div>
                                <div className="Socials__grid">
                                    {data.youtube.slice(0, 4).map(item => {
                                        return (
                                            <div key={item.url} className="Socials__grid-item">
                                                <ItemYoutube
                                                    data={item}
                                                    onOpen={setSelectedYoutubeUrl}
                                                />
                                            </div>
                                        );
                                    })}
                                </div>
                                {socialLinks.youtube && (
                                    <div className="Socials__footer Socials__footer--no-gap">
                                        <Button
                                            type={ButtonTypeEnum.Anchor}
                                            className="Socials__footer-action"
                                            link={socialLinks.youtube}
                                        >
                                            View more
                                        </Button>
                                    </div>
                                )}
                            </div>
                        )}
                    </>
                )}

                <Modal
                    isOpened={!!selectedYoutubeUrl}
                    close={() => setSelectedYoutubeUrl(null)}
                    hasInner={false}
                    closeOnOutsideClick
                >
                    <div className="Socials__youtube-frame-wrapper">
                        <iframe
                            id="ytplayer"
                            className="Socials__youtube-frame"
                            title="h"
                            chain-data__tweets
                            width="100%"
                            height="100%"
                            allow="autoplay"
                            allowFullScreen
                            src={`${selectedYoutubeUrl}?autoplay=1&rel=0`}
                            frameBorder={0}
                        />
                    </div>
                </Modal>
                {!isLoading && !isChainSocialLoading && !hasData && (
                    <div className="Socials__no-data">No current Socials updates</div>
                )}
            </SectionContent>
        </div>
    );
};

export default React.memo(Socials);
